/** Мутация установки нового пароля по коду из письма. */
import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { authKeys } from "./keys";

export const useResetPassword = () => {
	const mutation = useMutation({
		mutationFn: Api.Auth.postApiAuthPasswordReset,
		mutationKey: authKeys.resetPassword,
	});

	return {
		execute: mutation.mutateAsync,
		isPending: mutation.isPending,
	};
};
